export default __webpack_public_path__ + "static/media/swan.3c00c0e8.png";